<template>
  <div>
    <template v-if="row">
      <div
        :class="{
          'border-b border-dashed border-gray-50 mb-2':
            id === 1 || id === 4 || id === 8,
        }"
        class="relative flex"
      >
        <div class="relative w-full flex-y-center justify-between gap-2">
          <div
            class="relative z-10 bg-white px-1 text-gray text-xs font-medium"
          >
            {{ $t(title) }}
          </div>
          <div
            class="relative z-10 bg-white px-1 text-dark-100 text-xs font-medium whitespace-nowrap"
          >
            <slot name="content">
              {{ value }}
              <span v-if="percent">
                (
                <span :class="percentColor">{{ percent }}%</span>
                )
              </span>
            </slot>
          </div>
        </div>
        <br />
      </div>
    </template>
    <template v-else>
      <FGroup :label="$t(title)" label-class="text-xs text-gray" class="!gap-1">
        <span class="text-sm text-left"> {{ value }}</span>
      </FGroup>
    </template>
  </div>
</template>

<script setup lang="ts">
import FGroup from "@/components/Form/FGroup.vue";

import { computed } from "vue";

interface Props {
  title: string;
  percent?: number;
  value: number | string;
  id: number;
  row?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  row: false,
});

const percentColor = computed(() =>
  props?.percent > 0 ? "text-green" : "text-red",
);
</script>

<style scoped></style>
